import {gsap} from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import {Swiper} from 'swiper'
import {FreeMode, Navigation} from 'swiper/modules'
import {breakpointUp, getScreenWidth} from '../../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)
let hScrolls = []
let swipers = []

window.horizontalPinnedScroll = () => {

  const sliderContainers = document.querySelectorAll('.horizontal-pinned-scroll-cards')
  if (!sliderContainers.length) return false;

  const clearHorizontalPinnedScroll = (sliderContainer, index) => {
    if (hScrolls[index]) {
      ScrollTrigger.getById(`horizontalPinnedScroll${index}`).kill(true);
      hScrolls[index].kill(true);
      hScrolls[index] = null;
    }
  }
  const clearSwiperCarousel = (sliderContainer, index) => {
    if (swipers[index]) {
      swipers[index].destroy(true, true); // Destroy Swiper instance
      swipers[index] = null; // Set swiper to null
    }

    $(sliderContainer).find('.swiper-slide').removeAttr('style');
    $(sliderContainer).find('.swiper-wrapper').removeAttr('style');

  }

  sliderContainers.forEach((sliderContainer, index) => {

    clearHorizontalPinnedScroll(sliderContainer, index);
    clearSwiperCarousel(sliderContainer, index);
    if ($(window).width() > 991) {
      let speed = 1.5
      let widthElements = sliderContainer.querySelectorAll('.swiper-slide')
      let scrollWidth = $(window).width() * -0.945

      widthElements.forEach(element => {
        scrollWidth += element.clientWidth
      })

      let sliderWrapper = sliderContainer.querySelector('.swiper-wrapper')
      let pinnedElement = sliderContainer.closest('.block-container')

      hScrolls[index] = gsap.to(sliderWrapper, {
        x: -scrollWidth,
        ease: "none",
        scrollTrigger: {
          id: `horizontalPinnedScroll${index}`,
          trigger: pinnedElement,
          pin: true,
          scrub: 1,
          start: 'bottom bottom',
          end: `+=${scrollWidth / speed}`
        }
      })


    } else {

      let sliderSwiper = sliderContainer.querySelector('.swiper')
      let nextBtn = sliderContainer.querySelector('.swiper-nav-next')
      let prevBtn = sliderContainer.querySelector('.swiper-nav-prev')

      swipers[index] = new Swiper(sliderSwiper, {
        modules: [FreeMode, Navigation],
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: {
          enabled: true
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        loop: true,
      })
    }
  })
}

horizontalPinnedScroll();
